/**
 * Mutates the input object by removing all null values from arrays.
 *
 * Useful for formatting data for audits, as stimulsoft cannot handle null values in arrays.
 */
export function removeNullsFromArrays(
  data: Record<string, any> | Record<string, any>[]
): Record<string, any> | Record<string, any>[] {
  if (Array.isArray(data)) {
    return cleanArray(data);
  } else {
    return cleanObject(data);
  }
}

function cleanArray(arr: Record<string, any>[]): Record<string, any> {
  return arr.reduce((acc: Record<string, any>[], item) => {
    if (Array.isArray(item)) {
      acc.push(cleanArray(item));
    } else if (item && typeof item === 'object') {
      acc.push(cleanObject(item));
    } else if (item !== null) {
      acc.push(item);
    }
    return acc;
  }, []);
}

function cleanObject(obj: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (Array.isArray(value)) {
        result[key] = cleanArray(value);
      } else if (typeof value === 'object' && value !== null) {
        result[key] = removeNullsFromArrays(value);
      } else {
        result[key] = value;
      }
    }
  }
  return result;
}
